import {trans} from '@frontend/helpers'
import {useFilteredItemsLoader} from '@frontend/modules/public/ads/hooks/useFilteredItemsLoader'
import {ServicesList} from '@frontend/modules/public/services/components/list/ServicesList'
import type {ExecutorPreviewData} from '@frontend/modules/public/services/ServicesModuleTypes'
import {useAuthStore} from '@frontend/stores'
import clsx from 'clsx'
import {useEffect} from 'react'
import {Badge} from 'swayok-react-mdb-ui-kit/components/Typography/Badge'

// Список услуг на главной странице.
export function HomePageServicesSection() {

    const {
        loadItems,
        items,
        totalItemsCount,
        isLoading,
        isAllItemsLoaded,
        isLoadedOnce,
        onItemDataChange,
    } = useFilteredItemsLoader<ExecutorPreviewData>({
        type: 'services',
        listIdForAnalytics: 'home_page',
        pageLimit: 5,
        silenceErrors: true,
    })

    const loadingUserData = useAuthStore(
        state => state.loadingUserData
    )

    // Загрузка услуг при монтировании.
    useEffect(
        () => {
            if (!isLoadedOnce && !loadingUserData) {
                loadItems('filter')
            }
        },
        [loadingUserData]
    )

    if (!totalItemsCount) {
        return null
    }

    return (
        <section
            id="home-page-offered-services-section"
            className="mt-6"
        >
            <div
                className={clsx(
                    'd-flex flex-column align-items-stretch justify-content-start',
                    'flex-md-row align-items-md-center'
                )}
            >
                <div className="flex-1 d-flex flex-row align-items-center justify-content-between">
                    <div className="d-flex flex-row align-items-center justify-content-start">
                        <h1 className="my-0 offered-items-list-page-header">
                            {trans().services.list.home_page_header}
                        </h1>
                        {(totalItemsCount ?? 0) > 0 && (
                            <Badge
                                pill
                                color="red"
                                className="ms-3 fs-6 fw-400 align-middle d-inline-block"
                            >
                                {totalItemsCount}
                            </Badge>
                        )}
                    </div>
                </div>
            </div>
            <div className="flex-container-row mt-3 mt-sm-4">
                <ServicesList
                    executors={items}
                    isAllExecutorsLoaded={isAllItemsLoaded}
                    onLoadMore={() => loadItems('next', false)}
                    disabled={isLoading == 'next'}
                    onExecutorDataChange={onItemDataChange}
                />
            </div>
        </section>
    )
}
